<template>
	<section class="fx radio-bar">
		<p v-for="item in listBar" class="fx fx-y-center"><input class="radio" type="radio" :id="item.type" name="chack" :value="item.type"  v-model="activeBarModel" /><label :for="item.type">{{item.title}}</label></p>
  	</section>
</template>
<script>
	export default {
		name:"z-radio-bar",
		data() {
			return {
				listBar:this.listObj,
			}
		},
		/*
		 * 接收父组件数据
		 */
		props: {
			listObj: {//tabbar数组对象
				type:Array,
				default: [
					{
						title:'标题',
						type:'text'
					}
				],
			},
			active:{//当前选中的哪一个bar
				type:String,
				default: '',
			}
		},
		watch :{
	  	},
	  	/*
		 * 实例计算属性
		 */
		computed: {
			activeBarModel:{
				get() {
					return this.active
				},
				set(value) {
					this.$emit('handleClickRadioBar',value)
				}
			},
		},
		methods: {
		}
	}
</script>
<!-- 添加 scoped “范围”属性CSS限制这个组件只 -->
<style scoped lang="scss">
	@import "src/assets/css/common.scss";
	.radio-bar{
		p{
			padding-right: px-em(20px);
			label{
				padding-left: px-em(10px);
				cursor: pointer;
			}
			
		}
	}
</style>



// WEBPACK FOOTER //
// RadioBar.vue?c2f31202